// @ts-nocheck
/* eslint-disable */
export const tickSquareIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M10.794 1.333H5.207c-2.427 0-3.873 1.447-3.873 3.874v5.58c0 2.433 1.446 3.88 3.873 3.88h5.58c2.426 0 3.873-1.447 3.873-3.874V5.207c.007-2.427-1.44-3.874-3.867-3.874m.393 5.134-3.78 3.78a.5.5 0 0 1-.707 0L4.814 8.36a.503.503 0 0 1 0-.707.503.503 0 0 1 .706 0l1.534 1.534L10.48 5.76a.503.503 0 0 1 .707 0 .503.503 0 0 1 0 .707"/></svg>`,
    name: 'tick-square' as const
};